module.exports = __webpack_public_path__ + "img/form-2.fdbeb49f.png";